import {isAnyOf} from '@reduxjs/toolkit'

import {EnhancerOptions} from '@web/helpers/redux'
import {loggingAction} from '@web/middlewares/logger'
import {pageViewAction, uiEventAction} from '@web/middlewares/uiLogging'

const isFiltering = isAnyOf(uiEventAction, pageViewAction, loggingAction)

const SmartstoreResultSentryEnhancer: EnhancerOptions = {
    stateTransformer: () => {
        // 화이트 리스트 방식으로 필요한 값을 선택합니다.
        return {}
    },
    actionTransformer: (action) => {
        const actionType = action.type
        if (actionType.lastIndexOf('pending') > 0 || isFiltering(action)) {
            return null
        }
        return {
            ...action,
            payload: undefined,
        }
    },
}

export default SmartstoreResultSentryEnhancer
